import qs from "qs"
//私人消息和全员的
import PrivateDialog from './private-message.vue'
//回复评论和消息推送
import RespondDialog from './respond-message.vue'

export default {
  components: {
    PrivateDialog,
    RespondDialog
  },
  data() {
    return {
      //私人信息，弹框状态
      privateVisible: false,
      private_info: {}, //发送的数据信息，全员的私人的
      messageType: '', //区分模板信息的type

      //回复评论和消息推送,全员的和私人的。
      resmessage: {}, //发送的数据信息
      respondVisible: false, //弹框的状态
      titleType: '', //区分模板信息的type
    }
  },
  methods: {
    //置空page
    chearSearchState() {
      this.search.page = 1;
    },
    //移入黑名单
    moveBlacklist(api, params, operation) {
      if (params.state == 2) {
        this.$confirm('移入黑名单后，该用户将无法发表评论', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.blackOperation(api, params, operation);
        }).catch(() => {})
      } else if (params.state == 1) {
        this.blackOperation(api, params, operation);
      }
    },
    //移入移出操作
    blackOperation(api, params, operation) {
      api({
        params: params
      }).then(res => {
        if (res.resultCode == 1) {
          //做一些刷新操作
          operation();
          this.$message.success(res.result.msg);
        } else {
          this.$message.error(res.result.msg)
        }
      })
    },
    //撤回消息
    recallMessage(api, params, operation) {
      this.$confirm('您确定要撤回这条消息吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        api({
          params: params
        }).then(res => {
          if (res.resultCode == 1) {
            //做一些刷新操作
            operation();
            this.$message.success(res.errorMsg)
          } else {
            this.$message.error(res.errorMsg)
          }
        })
      }).catch(() => {})
    },
    //私人消息和全员消息的模板公用
    privateMessage(item, type) {
      // type
      //1.私人消息
      //2.全员消息----表格里面的内容（需要根据表格内容的状态来判断私人或者是全员）
      //  console.log(item,type);
      item == null ? item = null : item;
      // console.log(item);
      this.private_info = {
        ...item
      };
      this.messageType = String(type);
      this.privateVisible = true;
    },
    //回复评论，消息推送
    respondMessage(item, type) {
      // type
      //1.回复评论
      //3.消息推送和反馈信息的展示
      // console.log(item,type)
      this.resmessage = {
        ...item
      };
      this.titleType = String(type);
      this.respondVisible = true;
    }
  },

}
